import React from "react";
import { Grid } from "@client/shared/components";
import { noop } from "@client/shared/constants";
import Paper from "@mui/material/Paper";
import style from "./style";

const WhitelistView = ({
  entries = [],
  entriesCount = 0,
  columnConfig = [],
  pageNumber = 1,
  pageSize = 5,
  order = null,
  orderBy = "",
  isLoading = false,
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSortChange = noop,
  handleSelectionChange = noop,
  handleGridReady = noop,
}) => {
  return (
    <Paper elevation={0} sx={style.tableContainer}>
      <Grid
        hasPagination
        rows={entries}
        totalRows={entriesCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        order={order}
        orderBy={orderBy}
        columns={columnConfig}
        isLoading={isLoading}
        onPageNumberChange={handlePageNumberChange}
        onPageSizeChange={handlePageSizeChange}
        onSortChange={handleSortChange}
        onSelectionChange={handleSelectionChange}
        onReady={handleGridReady}
        classes={{
          container: style.tableContainer,
        }}
        entriesText="Clients"
      />
    </Paper>
  );
};

export default WhitelistView;
